<script>
import { Tabs, Tab } from 'vant'
import OrganizationBasicInfo from '@/components/org/OrganizationBasicInfo'
import OrganizationAuthenticationInfo from '@/components/org/OrganizationAuthenticationInfo'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-organization-detail',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-tabs': Tabs,
        'van-tab': Tab,
        'organization-basic-info': OrganizationBasicInfo,
        'organization-authentication-info': OrganizationAuthenticationInfo,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            organization: {
                id: null,
                name: null,
                logoUrl: null,
                area: null,
                contact: null,
                position: null,
                authStatus: null,
            },
            authentication: {
                id: null,
                status: null,
                type: null,
                businessFullName: null,
                businessLicencePicUrl: null,
                businessLicencePic: null,
                businessLicenceCode: null,
                businessLicenceStartDate: null,
                businessLicenceEndDate: null,
                credentialType: null,
                credentialFullName: null,
                credentialPicUrl: null,
                credentialPic: null,
                credentialCode: null,
                credentialStartDate: null,
                credentialEndDate: null,
                credentialRegistrationAddress: null,
                userFullName: null,
                userFacePhotoPicUrl: null,
                userFacePhotoPic: null,
                userNationalEmblemPicUrl: null,
                userNationalEmblemPic: null,
                userIndentityCode: null,
                userPhone: null,
            },
            selectedTabIndex: null,
            locale: {}
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
    },

    //--------------------------------------------------
    // component watch
    //--------------------------------------------------
    watch: {
        selectedTabIndex(value) {
            this.onTabClick(value)
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onTabClick(index) {
            console.log('onTabClick', this.selectedTabIndex, index)
            if (index == null || isNaN(index)) {
                index = 0
            }
            console.log('@index', index, this.selectedTabIndex == index)
            if (this.selectedTabIndex != index) {
                this.selectedTabIndex = index
            }
            else {
                console.log('dispatch the tab event')
                this.$emit('custom-event', {
                    type: 'tab',
                    data: {
                        index: this.selectedTabIndex
                    }
                })
            }            
        },
        onOrganizationEdit() {
           this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgEditOrganization',
                    params: { id: this.organization.id }
                }
            })
        },
        onAuthenticationSubmit(data) {
            console.log('onAuthenticationSubmit', data)
            this.$emit('custom-event', {
                type: 'save-auth',
                data: data
            })
        },
    },
}
</script>

<template>
    <div class="organization-detail">
        <van-tabs sticky v-model="selectedTabIndex">
            <van-tab :title="locale['basic-info']">
                <organization-basic-info 
                    :organization="organization"
                    @edit-organization="onOrganizationEdit"
                />
            </van-tab>
            <van-tab :title="locale['organization-authentication']">
                <organization-authentication-info
                    :authentication="authentication"
                    @submit-data="onAuthenticationSubmit"
                />
            </van-tab>
        </van-tabs>
    </div>
</template>